import React from 'react'
import { RouterContextType } from './types'

const Context = React.createContext<RouterContextType>({ name: 'Routes' })

export default Context
